/**
 * Service for fetching tourable specifications for communities and plans.
 * Uses RxJS observables to handle asynchronous API calls and errors gracefully.
 */
import { catchError, of, switchMap } from "rxjs";
import getCommunityTourableSpecs$ from "../apis/getCommunityTourableSpecs";
import getPlanTourableSpec$ from "../apis/getPlanTourableSpecs";

/**
 * Fetches tourable specifications for a given community ID.
 * Returns an observable that emits the specs array or an empty array on error.
 *
 * @param {string|number} communityId - The ID of the community.
 * @returns {Observable<Array>} Observable emitting the tourable specs array.
 */
export const getTourableSpecsByCommunityId$ = (communityId) =>
    getCommunityTourableSpecs$(communityId).pipe(
        switchMap((tourableSpecs) => of(tourableSpecs)),
        catchError(() => of([])),
    );

/**
 * Fetches tourable specifications for a given plan ID.
 * Returns an observable that emits the specs array or an empty array on error.
 *
 * @param {string|number} planId - The ID of the plan.
 * @returns {Observable<Array>} Observable emitting the tourable specs array.
 */
export const getTourableSpecsByPlanId$ = (planId) =>
    getPlanTourableSpec$(planId).pipe(
        switchMap((tourableSpecs) => of(tourableSpecs)),
        catchError(() => of([])),
    );